import { Icon, type IconName } from "../icons";
import { cn } from "../utils";

/** Props Interface */
interface MapViewMarkerProps {
	iconName: IconName;
	color: string;
	className?: string;
}

export function MapViewMarker({ iconName, color, className }: MapViewMarkerProps) {
	return (
		<div className="v-stack items-center relative">
			<div
				className={cn(
					"w-10 h-10 rounded-full border-2 flex-center bg-white",
					"absolute left-[50%] -translate-x-[50%] bottom-[calc(100%-0.3rem)]",
					"z-[1]",
					className,
				)}
				style={{
					borderColor: color,
				}}
			>
				<Icon
					name={iconName}
					color={color}
					size={18}
				/>
			</div>
			<div
				className="w-2 aspect-square rounded-br-xs rotate-45 relative z-0"
				style={{ backgroundColor: color }}
			/>
		</div>
	);
}
